export enum EnumAccionRespuesta {
    errorBusqueda = 1,
    noExistePadron = 3,
    padronDesactivado = 0,
    busquedaCorrecta = 2
  };